import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@morningstar/shared/environment';
import { Category } from './category';
import { Observable } from 'rxjs';

@Injectable()
export class CategoryService {

  constructor(private httpClient: HttpClient, @Inject('API_BASE_URL') private baseHref: string) { }

  get(includeAll: boolean = false): Observable<Category[]> {
    return this.httpClient.get<Category[]>(`${this.baseHref + environment.api.category.get}`.replace('{includeAll}', includeAll.toString()));
  }
}
